import { useContext, useEffect } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { ProjectCheckpointForm } from '../components/projectOverview/ProjectCheckpointForm';
import { useParams } from 'react-router-dom';

export const CreateProjectCheckpointPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);
    const { projectId } = useParams();
    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Crear seguimiento');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Seguimientos',
                route: `/projects/projects-list/${projectId}`,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_PROJECT_CHECKPOINTS_PAGE,
            },
        ]);
    }, [lang]);
    return (
        <ProjectCheckpointForm isNewProjectCheckpoint={true} projectId={projectId} />
    );
};
